import React from "react";
import { PromoRibbon as PromoRibbonStyled } from "./style";
import { Colors } from "themes/color-palette";
import { HubbleBody, HubbleLink } from "../Typography";

interface PromoRibbonProps {
  text: string;
  linkHref: string;
  linkLabel: string;
  style?: React.CSSProperties;
  isMobile?: boolean;
}

const PromoRibbon = ({
  style,
  text,
  linkHref,
  linkLabel,
  isMobile
}: PromoRibbonProps) => {
  return (
    <PromoRibbonStyled style={style} isMobile={isMobile}>
      <HubbleBody
        size={isMobile ? "sm" : "lg"}
        style={{
          whiteSpace: isMobile ? "break-spaces" : "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
        as={"span"}
        color={Colors.black}
        bold={!isMobile}
        semiBold={isMobile}
      >
        {text}
      </HubbleBody>
      <HubbleLink
        size={isMobile ? "sm" : "lg"}
        color={Colors.black}
        target="_blank"
        rel="noopener noreferrer"
        href={linkHref ?? ""}
        ml={0.5}
        style={{ whiteSpace: "nowrap" }}
        bold={!isMobile}
        semiBold={isMobile}
      >
        {linkLabel}
      </HubbleLink>
    </PromoRibbonStyled>
  );
};

export default PromoRibbon;
